import { Button } from '@kizen/kds/Button';
import { StyledClipBoardButton } from './styles';
import { useTranslation } from 'react-i18next';
import { FC, useRef, useState } from 'react';

export const ClipboardButton: FC<{ value: string }> = ({ value }) => {
  const { t } = useTranslation();

  const [copied, setCopied] = useState(false);

  const timeoutRef = useRef<NodeJS.Timeout>();

  const handleCopyToClipboard = () => {
    clearTimeout(timeoutRef.current);
    navigator.clipboard.writeText(value);
    setCopied(true);
    timeoutRef.current = setTimeout(() => {
      setCopied(false);
    }, 2000);
  };

  return (
    <StyledClipBoardButton>
      <Button
        key={String(copied)}
        leftIcon="custom-clipboard"
        leftIconSettings={{
          size: 'md',
          tooltipDescriptionOverride: copied
            ? t('Copied')
            : t('Copy to Clipboard'),
        }}
        variant="text"
        color="secondary"
        onClick={handleCopyToClipboard}
      />
    </StyledClipBoardButton>
  );
};
